import DispatcherStatementCreateService
from '@/services/accounting.services/dispatchers-statements-create-form.service';
import store from '../../../../index';
import { httpClient } from "@/services";

export default {
	state: {
		dispatcher_rate: '',
		statementsCreateFormList: [],
		statementsCreateFilter: {},
		statementsMonthList: [],
		loadInfo: [],
		loadInfoFilter: {},
		rate: '',
		statementsExportLoadsLink: null
	},
	mutations: {
		// Dear feature vue programmer, can u please change name of this SHIT
		SET_HUET_CHECKER(state, payload) {
			const index = state.statementsCreateFormList.findIndex(e => e.dispatcher_id === payload.dispatcher_id);
			state.statementsCreateFormList.splice(index, 1, payload);
		},
		SET_DISPATCHERS_STATEMENTS_FOR_INFO(state, payload) {
			state.dispatcher_rate = payload.dispatcher_rate;
			state.statementsCreateFormList = [];
			payload.dispatchers.map(e => {
				e.checked = false;
			});
			state.statementsCreateFormList = payload.dispatchers;
			state.statementsCreateFilter = payload.filter;
			state.statementsMonthList = payload.month;
		},
		GET_LOAD_INFO(state, payload) {
			state.loadInfo = payload;
			state.loadInfoFilter = payload;
		},
		SET_RATE(state, payload) {
			state.rate = payload;
		},
		updateStatementsExportLoadsLink(state, payload) {
			state.statementsExportLoadsLink = payload;
		},
	},
	actions: {
		// Checker for checkboxes
		setCheck({ commit }, payload) {
			commit("SET_HUET_CHECKER", payload);
		},
		// Main list
		async getDispInfo({ commit }, payload) {
			store.dispatch("actionPreloader", true);
			try {
				const data = await DispatcherStatementCreateService.getListDispStatementsCreateForm(payload);
				commit('SET_DISPATCHERS_STATEMENTS_FOR_INFO', data.data);
				store.dispatch("actionPreloader", false);
			} catch (error) {
				console.error(error);
			}
		},
		async getDispInfoDate({ commit }) {
			store.dispatch("actionPreloader", true);
			try {
				const data = await DispatcherStatementCreateService.getListDispStatementsCreate();
				commit('SET_DISPATCHERS_STATEMENTS_FOR_INFO', data.data);
				store.dispatch("actionPreloader", false);
				return data;
			} catch (error) {
				console.error(error);
			}
		},
		async updateListDispStatementsCreateList({ commit }, payload) {
			store.dispatch("actionPreloader", true);
			try {
				const data = await DispatcherStatementCreateService.getListDispStatementsCreateList(payload);
				commit('SET_DISPATCHERS_STATEMENTS_FOR_INFO', data.data);
				store.dispatch("actionPreloader", false);
				return data;
			} catch (error) {
				console.error(error);
			}
		},
		// Fore every load
		async getLoadInfo({ commit }, payload) {
			store.dispatch("actionPreloader", true);
			try {
				const data = await DispatcherStatementCreateService.getLoadsInfo(payload.date, payload.id);
				commit('GET_LOAD_INFO', data.data);
				store.dispatch("actionPreloader", false);
			} catch (error) {
				console.error(error);
			}
		},
		// FilterTable Fore every load
		async updateLoadInfoFilter({ commit, dispatch }, payload) {
			dispatch("actionPreloader", true);
			try {
				const filter = payload.filter ? payload.filter : {};
				filter.date = payload.date ? payload.date : "";
				filter.dispatcher_id = payload.id ? payload.id : "";

				const data = await DispatcherStatementCreateService.getLoadsInfoFilter(filter);
				commit('GET_LOAD_INFO', data.data);
				dispatch("actionPreloader", false);
			} catch (error) {
				console.error(error);
			}
		},
		async getStatementsLoadsExport({ commit, dispatch }, payload) {
			const { value, id } = payload;
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post(`dispatcher/statement/${ id }/export`, value);
				if (data) {
					commit('updateStatementsExportLoadsLink', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		// For rates
		async getRateInfo({ commit }, payload) {
			store.dispatch("actionPreloader", true);
			try {
				const data = await DispatcherStatementCreateService.getRate(payload.value, payload.date);
				commit('SET_RATE', data.data);
				commit('SET_DISPATCHERS_STATEMENTS_FOR_INFO', data.data);
				store.dispatch("actionPreloader", false);
			} catch (error) {
				console.error(error);
			}
		}
	},
	getters: {
		getStatementsMonthList(state) {
			return state.statementsMonthList;
		},
		getStatementsCreateFilter(state) {
			return state.statementsCreateFilter;
		},
		getStatementsFormList(state) {
			return state.statementsCreateFormList;
		},
		getChosenDisp(state) {
			const filteredChosen = state.statementsCreateFormList.filter(item => item.checked === true);
			return filteredChosen;
		},
		getLoadInfo(state) {
			return state.loadInfo;
		},
		getLoadInfoFilter(state) {
			return state.loadInfoFilter;
		},
		getDispRate(state) {
			return state.dispatcher_rate;
		},
		getRate(state) {
			return state.rate;
		},
		statementsExportLoadsLink: s => s.statementsExportLoadsLink,
	}
};
